import { useState } from "react"
import { HeroSlideshow } from "./HeroSlideShow";

 const  photos =  [
    {
      "caption": "15",
      "url": "/media/photos/001.jpeg"
    },
    {
      "caption": "16",
      "url": "/media/photos/002.jpeg"
    },
    {
      "caption": "VMD001Drone.jpg",
      "url": "/media/photos/003.jpeg"
    },
    {
      "caption": "VMD002Drone.jpg",
      "url": "/media/photos/004.jpeg"
    },
    {
      "caption": "VMD003Drone.jpg",
      "url": "/media/photos/005.jpeg"
    },
    {
      "caption": "VMD004Drone.jpg",
      "url": "/media/photos/006.jpeg"
    },
    {
      "caption": "21",
      "url": "/media/photos/007.jpeg"
    },
    {
      "caption": "17",
      "url": "/media/photos/008.jpeg"
    },
    {
      "caption": "18",
      "url": "/media/photos/009.jpeg"
    },
    {
      "caption": "22",
      "url": "/media/photos/010.jpeg"
    },
    {
      "caption": "20",
      "url": "/media/photos/011.jpeg"
    },
    {
      "caption": "24",
      "url": "/media/photos/012.jpeg"
    },
    {
      "caption": "25",
      "url": "/media/photos/013.jpeg"
    },
    {
      "caption": "26",
      "url": "/media/photos/014.jpeg"
    },
    {
      "caption": "27",
      "url": "/media/photos/015.jpeg"
    },
    {
      "caption": "28",
      "url": "/media/photos/016.jpeg"
    },
    {
      "caption": "23",
      "url": "/media/photos/017.jpeg"
    },
    {
      "caption": "3",
      "url": "/media/photos/018.jpeg"
    },
    {
      "caption": "4",
      "url": "/media/photos/019.jpeg"
    },
    {
      "caption": "5",
      "url": "/media/photos/020.jpeg"
    },
    {
      "caption": "6",
      "url": "/media/photos/021.jpeg"
    },
    {
      "caption": "7",
      "url": "/media/photos/022.jpeg"
    },
    {
      "caption": "8",
      "url": "/media/photos/023.jpeg"
    },
    {
      "caption": "9",
      "url": "/media/photos/024.jpeg"
    },
    {
      "caption": "10",
      "url": "/media/photos/025.jpeg"
    },
    {
      "caption": "11",
      "url": "/media/photos/026.jpeg"
    },
    {
      "caption": "19",
      "url": "/media/photos/027.jpeg"
    },
    {
      "caption": "29",
      "url": "/media/photos/028.jpeg"
    },
    {
      "caption": "1",
      "url": "/media/photos/029.jpeg"
    },
    {
      "caption": "2",
      "url": "/media/photos/030.jpeg"
    },
    {
      "caption": "30",
      "url": "/media/photos/031.jpeg"
    },
    {
      "caption": "VMD008Drone.jpg",
      "url": "/media/photos/032.jpeg"
    },
    {
      "caption": "VMD007Drone.jpg",
      "url": "/media/photos/033.jpeg"
    },
    {
      "caption": "VMD006Drone.jpg",
      "url": "/media/photos/034.jpeg"
    },
    {
      "caption": "12",
      "url": "/media/photos/035.jpeg"
    },
    {
      "caption": "13",
      "url": "/media/photos/036.jpeg"
    },
    {
      "caption": "14",
      "url": "/media/photos/037.jpeg"
    },
    {
      "caption": "VMD005Drone.jpg",
      "url": "/media/photos/038.jpeg"
    },
    {
      "caption": "VMD001.jpg",
      "url": "/media/photos/039.jpeg"
    },
    {
      "caption": "VMD002.jpg",
      "url": "/media/photos/040.jpeg"
    },
    {
      "caption": "VMD003.jpg",
      "url": "/media/photos/041.jpeg"
    },
    {
      "caption": "VMD004.jpg",
      "url": "/media/photos/042.jpeg"
    },
    {
      "caption": "VMD005.jpg",
      "url": "/media/photos/043.jpeg"
    },
    {
      "caption": "VMD006.jpg",
      "url": "/media/photos/044.jpeg"
    },
    {
      "caption": "VMD007.jpg",
      "url": "/media/photos/045.jpeg"
    },
    {
      "caption": "VMD008.jpg",
      "url": "/media/photos/046.jpeg"
    },
    {
      "caption": "VMD009.jpg",
      "url": "/media/photos/047.jpeg"
    },
    {
      "caption": "VMD010.jpg",
      "url": "/media/photos/048.jpeg"
    },
    {
      "caption": "VMD011.jpg",
      "url": "/media/photos/049.jpeg"
    },
    {
      "caption": "VMD012.jpg",
      "url": "/media/photos/050.jpeg"
    },
    {
      "caption": "VMD013.jpg",
      "url": "/media/photos/051.jpeg"
    },
    {
      "caption": "VMD014.jpg",
      "url": "/media/photos/052.jpeg"
    },
    {
      "caption": "VMD015.jpg",
      "url": "/media/photos/053.jpeg"
    },
    {
      "caption": "VMD016.jpg",
      "url": "/media/photos/054.jpeg"
    },
    {
      "caption": "VMD017.jpg",
      "url": "/media/photos/055.jpeg"
    },
    {
      "caption": "VMD018.jpg",
      "url": "/media/photos/056.jpeg"
    },
    {
      "caption": "VMD019.jpg",
      "url": "/media/photos/057.jpeg"
    },
    {
      "caption": "VMD020.jpg",
      "url": "/media/photos/058.jpeg"
    },
    {
      "caption": "VMD021.jpg",
      "url": "/media/photos/059.jpeg"
    },
    {
      "caption": "VMD022.jpg",
      "url": "/media/photos/060.jpeg"
    },
    {
      "caption": "VMD023.jpg",
      "url": "/media/photos/061.jpeg"
    },
    {
      "caption": "VMD024.jpg",
      "url": "/media/photos/062.jpeg"
    },
    {
      "caption": "VMD025.jpg",
      "url": "/media/photos/063.jpeg"
    },
    {
      "caption": "VMD026.jpg",
      "url": "/media/photos/064.jpeg"
    },
    {
      "caption": "VMD027.jpg",
      "url": "/media/photos/065.jpeg"
    },
    {
      "caption": "VMD028.jpg",
      "url": "/media/photos/066.jpeg"
    },
    {
      "caption": "VMD029.jpg",
      "url": "/media/photos/067.jpeg"
    },
    {
      "caption": "VMD030.jpg",
      "url": "/media/photos/068.jpeg"
    }
  ]


function photoThumb(largeUrl){
  if (largeUrl.startsWith('/media/')) return largeUrl;
  return largeUrl.replace('/resized/large/large-', '/resized/thumbnail/thumbnail-');
}

const INITIAL_GRID = 18;


export  default function Gallery() {
  const [index, setIndex] = useState(0);
  const [view, setView] = useState('slideshow');
  const [gridExpanded, setGridExpanded] = useState(false);

  const gridCount = gridExpanded ? photos.length : Math.min(INITIAL_GRID, photos.length);

  return (
    <section className="section" id="images">
      <h2 className="section__title">Images</h2>

      <div className="view-toggle">
        <button
          type="button"
          className={view === 'slideshow' ? 'is-active' : ''}
          onClick={() => setView('slideshow')}
        >
          Slideshow
        </button>
        <button
          type="button"
          className={view === 'grid' ? 'is-active' : ''}
          onClick={() => setView('grid')}
        >
          Photo Grid
        </button>
      </div>

      {view === 'slideshow' && (
        <HeroSlideshow photos={photos} index={index} onSelect={setIndex} />
      )}

      {view === 'grid' && (
        <>
          <div className="photo-grid">
            {photos.slice(0, gridCount).map((p) => (
              <button
                key={p.url}
                type="button"
                className="photo-grid__cell"
                onClick={() => {
                  const idx = photos.indexOf(p);
                  setIndex(idx);
                  setView('slideshow');
                }}
              >
                <img src={photoThumb(p.url)} alt={p.caption} loading="lazy" />
              </button>
            ))}
          </div>
          {photos.length > INITIAL_GRID && (
            <button
              type="button"
              className="show-more"
              onClick={() => setGridExpanded((e) => !e)}
            >
              {gridExpanded ? 'Hide' : 'Show more'}
            </button>
          )}
        </>
      )}
    </section>
  );
}
